import { Link } from 'react-router';
import { Bouton } from '../shared/ui/Bouton';
import { Titre } from '../shared/ui/Titre';
import { ADRESSE_DE_L_ACCUEIL } from '../shared/les-huit-pages';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **LA PAGE DE REFUS — F-69, ET ELLE N'EST PAS UNE NEUVIÈME PAGE.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * F-69 : « une adresse demandée qui ne correspond à aucune des huit pages rend une page de
 * refus **qui renvoie à l'accueil**, et elle **NE LIT PAS LA BASE**. » Le critère 1 en fait
 * une exigence vérifiable : « le système DOIT rendre la page de refus **sans exécuter aucune
 * requête en base** ».
 *
 * Le brief de maquette la nomme S-23 et écrit son statut : « c'est une surface tranchée qui
 * **ne figure pas dans la liste fermée des huit pages**, et c'est écrit plutôt que laissé à
 * découvrir. Elle n'est pas une neuvième page au sens de la règle 46 — **ni contenu propre,
 * ni entrée dans la navigation, et elle ne lit pas la base**. »
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **CE COMPOSANT N'APPELLE RIEN, ET LE MOTIF EST PLUS LOURD QU'UNE ÉCONOMIE DE REQUÊTE.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Pas de hook de données, pas de client d'API importé, et pas de cadre non plus — donc pas
 * de carrousel par la porte de derrière. L'accueil du site **lit la base à chaque visite,
 * sans personne connectée** : une page de refus qui porterait le cadre complet ferait la
 * même lecture, et **offrirait ce chemin à n'importe quelle adresse tapée au hasard**. Sur
 * la seule route du produit qui n'est bornée par aucun compte et par aucun plafond d'appels
 * (D-028), ce n'est pas une nuance.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **ELLE RENVOIE À L'ACCUEIL, ET C'EST LE CAS DEPUIS LE LOT-6.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Au LOT-4b, `site/` ne portait **que** la page de connexion (D-066), et ce composant
 * renvoyait donc là, avec sa condition écrite : « **elle renvoie à l'accueil, qui arrive au
 * LOT-6** : en attendant, elle renvoie à la connexion, seule page existante. **Le lien
 * change quand l'accueil naît.** » L'accueil est né, le lien a changé.
 */
export function PageDeRefus() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-fond-travail p-8">
      <div className="flex max-w-etroite flex-col items-center gap-4 text-center">
        <Titre niveau={1}>Cette page n’existe pas</Titre>
        <p className="text-16 leading-normal text-texte-faible">
          L’adresse demandée ne correspond à aucune page de ce site.
        </p>
        {/* **`Link` et non un rechargement** : la page de refus fait partie de la même
            application, et l'accueil est une de ses routes. */}
        <Link to={ADRESSE_DE_L_ACCUEIL}>
          <Bouton>Retourner à l’accueil</Bouton>
        </Link>
      </div>
    </div>
  );
}
